import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private readonly isLoading = signal<boolean>(false);
  private readonly loadingText = signal<string>('Loading...');
  private loadingCount = 0;

  show(text?: string): void {
    this.loadingCount++;
    this.isLoading.set(true);
    if (text) {
      this.loadingText.set(text);
    }
  }

  hide(): void {
    this.loadingCount = Math.max(0, this.loadingCount - 1);
    if (this.loadingCount === 0) {
      this.isLoading.set(false);
    }
  }

  setText(text: string): void {
    this.loadingText.set(text);
  }

  forceHide(): void {
    this.loadingCount = 0;
    this.isLoading.set(false);
  }

  getIsLoading() {
    return this.isLoading.asReadonly();
  }

  getLoadingText() {
    return this.loadingText.asReadonly();
  }
}

